const createScriptTag = (api) => {
  let tag = document.createElement('script');
  tag.src = api;
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

const init = () => {
  const captchaHiddenInput = document.querySelector('.js-recaptcha');
  const validationErrors = document.querySelectorAll('.field-validation-error');

  if (captchaHiddenInput) {
    const formInputs =
      [...document.querySelectorAll('.umbraco-forms-form input')];
    formInputs.forEach(input => {
      input.addEventListener('focus', function () {
        createScriptTag(captchaHiddenInput.value);
      });
    }); 
  }

  if (validationErrors.length) {
    createScriptTag(captchaHiddenInput.value);
  }
};

const handleRecaptchav2 = {
  init,
};

export default handleRecaptchav2;
